import instance from '../utils/api_instance.util';

export const fetchFeedbackListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/feedback/list', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}
